<script lang="ts">
  import { xhr } from "$app/utils/xhr"
  import { toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"
  import { LoaderCircle, Check } from "lucide-svelte"

  interface Props {
    task: TaskType
    class?: string
    onupdate: (data: TaskType) => void
  }

  let { task, onupdate, class: css }: Props = $props()

  const departments: DepartmentType[] = appStore.departments
  const users: UserType[] = appStore.users

  function updateStore(data: TaskType): void {
    const idx = appStore.tasks.findIndex((t) => t.id === task.id)
    try {
      data.expected_at = new Date(`${data.expected_at}T00:00:00`)
    } catch (e) {}
    appStore.tasks[idx] = data
    task = data
  }

  let saving = $state(false)
  let saved = $state(false)
  async function handleSelect(
    assignee_id,
    assignee_type: string
  ): Promise<void> {
    saving = true
    const data = {
      assignee_id: assignee_id,
      assignee_type: assignee_type
    }
    try {
      const res = await xhr.patch<TaskType>(
        `/plans/${task.plan_id}/tasks/${task.id}.json`,
        { task: data }
      )
      updateStore(res.data)
      onupdate({
        assignee_id,
        assignee_type,
        ...task
      })
      saved = true
      setTimeout(() => (saved = false), 500)
    } catch (e) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error updating the assignee", "error")
    } finally {
      saving = false
    }
  }
</script>

<div class="relative">
  <select
    id="assignee_id"
    value={`${task.assignee_type}-${task.assignee_id}`}
    class={css || ""}
    onchange={(e: Event) => {
      const target = e.target as HTMLSelectElement
      const [assignee_type, assignee_id] = target.value.split("-")

      handleSelect(+assignee_id, assignee_type)
    }}
  >
    <optgroup label="Departments">
      {#each departments as dept (dept.id)}
        <option value={`Department-${dept.id}`}>{dept.name}</option>
      {/each}
    </optgroup>
    <optgroup label="Members">
      {#each users as user (user.id)}
        <option value={`User-${user.id}`}>{user.name}</option>
      {/each}
    </optgroup>
  </select>
  {#if saving}
    <LoaderCircle
      class="text-gray-400 size-5 absolute top-1 right-0 animate-spin"
    />
  {/if}

  {#if saved}
    <Check class="text-green-500 size-5 absolute top-1 right-0" />
  {/if}
</div>
